import React, { useEffect, useState } from "react";
import dummyimage from "../img/default_avatar.jpg";
import InfiniteScroll from "react-infinite-scroll-component";
import { useDispatch, useSelector } from "react-redux";
import { searchRecomentedFriendsList } from "../redux/actions/PeerMenuListActions";
import { API_URL } from "../config/app-config";
import { getAllMembersDetails } from "../redux/actions/subjectActions";

export default function GroupCardV2({ subjectId, friendDescription }) {
  const dispatch = useDispatch();
  const { allMembersList, totalCommunityUser, connectionSeeMore } = useSelector(
    (state) => state.subjects
  );
  const [state, setState] = useState({
    page: 0,
    friendsList: [],
    suggestHasMore: true,
  });
  const updateState = (name, value) => {
    setState((previous) => ({
      ...previous,
      [name]: value,
    }));
  };
  useEffect(() => {
    fetchGroupMembers();
  }, []);

  const fetchGroupMembers = () => {
    dispatch(
      getAllMembersDetails(
        subjectId,
        "all",
        state.page,
        state.page ? true : false
      )
    );
    updateState("page", state.page + 1);
  };
  console.log("allMembersList", allMembersList);
  return (
    <InfiniteScroll
      dataLength={allMembersList.length}
      next={fetchGroupMembers}
      hasMore={connectionSeeMore}
      scrollableTarget="scrollableDiv3"
    >
      <div
        id="scrollableDiv3"
        style={{
          minHeight: "auto",
          maxHeight: "37rem",
          overflow: "auto",
          overflowX: "hidden",
        }}
      >
        {allMembersList &&
          allMembersList.map((item, index) => (
            <div
              key={index}
              className="card mb-3 flex-row friend-v2-card p-2 align-items-center"
            >
              <div className="post-avatar post-avatar-story post-me-2">
                <img
                  className="post-avatar-img rounded-circle text-secondary"
                  src={
                    API_URL +
                    "api/getUserPhoto/" +
                    item.userId +
                    "/" +
                    item.dName
                  }
                  alt=""
                  onError={({ currentTarget }) => {
                    currentTarget.onerror = null;
                    currentTarget.src = dummyimage;
                  }}
                  onClick={() => friendDescription(item.userId)}
                />
              </div>
              <div className="home-sub text-white">{item.userName}</div>
            </div>
          ))}
      </div>
    </InfiniteScroll>
  );
}
